export default __webpack_public_path__ + "static/media/Snd_TryF.b32deb79.mp3";